
export class Cliente{
    id: string;
    razonSocial : string;
    cta_SGC : string;
    ctaSap: string;
}
